/**
 * Табы (в карточке товара)
 */
import Swiper from 'swiper';

let tabs = {
  swiper: [],
  links: [],
};

document.querySelectorAll('.tabs').forEach(function(el, i) {
  tabs.swiper[i] = new Swiper('.tabs .swiper', {
    slidesPerView: 1,
    autoHeight: true,
    allowTouchMove: false,
    on: {
      activeIndexChange: function(swiper) {
        switchTab(i, swiper.activeIndex);
      }
    },
  });

  tabs.links[i] = el.querySelectorAll('.tabs__link');
  
  tabs.links[i].forEach(function(link, linkIndex) {
    link.addEventListener('click', function(e) {
      e.preventDefault();

      switchTab(i, linkIndex);
      
      tabs.swiper[i].slideTo(linkIndex);
    });
  });

});

document.querySelectorAll('.product-page a[data-tab-anchor]').forEach(function(link) {
  link.addEventListener('click', function(e) {
    const page = link.closest('.product-page');
    const tabsElement = page?.querySelector('.tabs');
    const tabsIndex = Array.from(document.querySelectorAll('.tabs')).indexOf(tabsElement);
    const target = tabsElement?.querySelector(link.getAttribute('href'));
    const slide = target?.closest('.swiper-slide');
    const slideIndex = Array.from(tabs.swiper[tabsIndex]?.slides ?? []).indexOf(slide);
    if (tabsIndex < 0 || slideIndex < 0) return;

    e.preventDefault();
    switchTab(tabsIndex, slideIndex);
    tabs.swiper[tabsIndex].slideTo(slideIndex, 0);
    tabs.swiper[tabsIndex].updateAutoHeight(0);
    requestAnimationFrame(function() {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
});

function switchTab(tabsIndex, activeTabIndex) {
  tabs.links[tabsIndex].forEach(item => {item.classList.remove('_active')});
  tabs.links[tabsIndex][activeTabIndex].classList.add('_active');
}
